<template>
  <modal ref="modal">
    <template #title>Zugangsdaten bearbeiten
      <span class="text-uppercase">({{ channel.channel }})</span>
    </template>
    <template #content>
      <div class="alert alert-warning" v-if="channel.channel === 'wordpress'">
        <strong>Wichtige Information für Wordpress</strong>
        <p>
          Erstellen Sie im Wordpress unter Benutzer > Anwendungspasswörter ein "Anwendungspasswort" und tragen Sie die
          Zugangsdaten wie folgt ein:
          <br> <br>
          <strong>URL:</strong> Wordpress-URL (sollte mit <code>https://</code> beginnen) <br>
          <strong>Benutzername:</strong> Wordpress-Benutzername <br>
          <strong>Passwort:</strong> Das generierte Anwedungspasswort
        </p>
      </div>
      <div class="form-group">
        <label for="url">URL</label>
        <input type="text" placeholder="https://" class="form-control" id="url" v-model="credentials[prefix + 'url']">
      </div>
      <div class="form-group">
        <label for="username">Benutzername</label>
        <input type="text" class="form-control" id="username" v-model="credentials[prefix + 'username']">
      </div>
      <div class="form-group">
        <label for="password">Passwort</label>
        <input type="password" class="form-control" id="password" v-model="credentials[prefix + 'password']">
      </div>
      <div class="alert alert-danger" v-if="error" v-html="error">
      </div>
    </template>
    <template #footer>
      <button class="btn btn-primary" @click="saveCredentials">Speichern</button>
    </template>
  </modal>
</template>

<script>
import Modal from "../../common/modal/Modal";
import {mapMutations} from "vuex";

export default {
  name: 'AddCredentialsModal',
  components: {Modal},
  props: ['credentials', 'prefix', 'channel'],
  methods: {
    setCredentialsValid(bool) {
      if (this.prefix === 'wp_') {
        this.setWpCredentialsAreValid(bool)
      } else {
        this.setSwCredentialsAreValid(bool);
      }
    },
    saveCredentials() {
      axios.post('/backend/client_api_credentials', {
        platform: this.channel.channel,
        credentials: this.credentials
      }).then(() => {
        this.getChannelCredentials();
        this.getBlogCategories();
        this.error = ''

        this.setCredentialsValid(true);

        let element = this.$refs.modal.$el
        $(element).modal('hide')
      }).catch(() => {
        this.setCredentialsValid(false);
        this.error = 'Mit den angegebenen Zugangsdaten konnte keine Verbindung hergestellt werden. Bitte überprüfen Sie Ihre Eingabe und versuchen Sie es noch einmal.'
      })
    },
    ...mapMutations(['getChannelCredentials', 'getBlogCategories', 'setWpCredentialsAreValid', 'setSwCredentialsAreValid'])
  },
  data() {
    return {
      error: ''
    }
  },
  mounted() {
  }
}
</script>

<style scoped>
</style>
